/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 1
// module chunks = 0